import { colors } from "./colors"
import { radii } from "./radii"
import { shadows } from "./shadows"

export const semanticTokens = {
  colors,
  radii,
  shadows,
}
